import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-package-history',
  templateUrl: './package-history.component.html',
  styleUrls: ['./package-history.component.css'],
})
export class PackageHistoryComponent implements OnInit {
  @Input() entityData: any;

  tableData = [
    {
      'Last Seen': '2 min ago',
      'location': 'BR-12-A1',
      'Entry Time': '7/25/2024 12:00:17 PM',
      'Exit Time': '7/25/2024 02:00:17 PM',
      'Status': '--',
    },
    {
      'Last Seen': '4 min ago',
      'location': 'BR-12-A6',
      'Entry Time': '7/24/2024 12:00:17 PM',
      'Exit Time': '7/24/2024 03:00:19 PM',
      'Status': '--',
    },
    {
      'Last Seen': '5 min ago',
      'location': 'BR-12-A3',
      'Entry Time': '7/21/2024 11:00:14 PM',
      'Exit Time': '7/22/2024 03:00:17 PM',
      'Status': '--',
    },
    {
      'Last Seen': '10 min ago',
      'location': 'BR-08-C1',
      'Entry Time': '7/20/2024 10:00:20 PM',
      'Exit Time': '7/20/2024 12:00:12 PM',
      'Status': '--',
    },
  ];

  constructor() {}

  ngOnInit(): void { }
}
